import { PermissionEnum } from '../models/permissions';

export const PermissionPipe = permission => {
    switch (permission) {
        case PermissionEnum.LOGIN:
            return 'Login';
        case PermissionEnum.CREATE_RULE_ALL:
            return 'Create All Rules';
        case PermissionEnum.CREATE_RULE_AML:
            return 'Create AML Rules';
        case PermissionEnum.CREATE_RULE_FRAUD:
            return 'Create Fraud Rules';
        case PermissionEnum.CREATE_RULE_RG:
            return 'Create RG Rules';
        case PermissionEnum.UPDATE_RULE_ALL:
            return 'Update All Rules';
        case PermissionEnum.UPDATE_RULE_AML:
            return 'Update AML Rules';
        case PermissionEnum.UPDATE_RULE_RG:
            return 'Update RG Rules';
        case PermissionEnum.UPDATE_RULE_FRAUD:
            return 'Update Fraud Rules';
        case PermissionEnum.CREATE_TEAM:
            return 'Create Teams';
        case PermissionEnum.CREATE_USER:
            return 'Create Users';
        case PermissionEnum.UPDATE_TEAM:
            return 'Update Team';
        case PermissionEnum.UPDATE_USER:
            return 'Update User';
        case PermissionEnum.UPDATE_ALERT_DISMISS:
            return 'Dismiss Alerts';
        case PermissionEnum.UPDATE_ALERT_DELEGATE:
            return 'Delegate Alerts';
        case PermissionEnum.VIEW_TEAM_LIST:
            return 'View Teams List';
        case PermissionEnum.VIEW_USER_LIST:
            return 'View Users List';
        case PermissionEnum.MANAGE_USERS:
            return 'Manage Users';
        case PermissionEnum.MANAGE_SIMULATIONS:
            return 'Manage Simulations';
        case PermissionEnum.VIEW_AUDIT_LOG:
            return 'View Audit Log';
        default:
            return permission;
    }
};
